import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Autoplay } from "swiper/modules";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import icon1 from "../../../assets/img/landingPageThree/sectionFour/icon1.png"
import icon2 from "../../../assets/img/landingPageThree/sectionFour/icon2.png"
import icon3 from "../../../assets/img/landingPageThree/sectionFour/icon3.png"
import icon4 from "../../../assets/img/landingPageThree/sectionFour/icon4.png"

import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

const DATA = [
  {
    id: 1,
    class: 'card1',
    titleKey: "lp3_op1_title",
    textKey: "lp3_op1_text",
    item1Key: "lp3_op1_item1",
    item2Key: "lp3_op1_item2",
    item3Key: "lp3_op1_item3",
    item4Key: "lp3_op1_item4",
  },
  {
    id: 2,
    class: 'card2',
    titleKey: "lp3_op2_title",
    textKey: "lp3_op2_text",
    item1Key: "lp3_op2_item1",
    item2Key: "lp3_op2_item2",
    item3Key: "lp3_op2_item3",
    item4Key: "lp3_op2_item4",
  }
];

function SectionFour() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="operations" className={`sectionFour ${isVisible ? "visible" : ""}`}>
        <Swiper
          className={`${isVisible ? "visible" : ""}`}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          effect={'fade'}
          modules={[Navigation, EffectFade, Autoplay]}
          speed={800}
          slidesPerView={"1"}
          spaceBetween={0}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {DATA.map((item) => (
            <SwiperSlide key={item.id}>
              <div className={`card ${item.class}`}>
                <div className="left">
                  <h1 className={`title ${isVisible ? "visible" : ""}`}>
                    {t(item.titleKey)}
                  </h1>
                  <p className={`text ${isVisible ? "visible" : ""}`}>
                    {t(item.textKey)}
                  </p>
                </div>
                <ul className={`itens ${isVisible ? "visible" : ""}`}>
                  <li>
                    <p>{t(item.item1Key)}</p>
                    <img src={icon1} alt="" width={'25px'}/>
                  </li>
                  <li>
                    <p>{t(item.item2Key)}</p>
                    <img src={icon2} alt="" width={'25px'}/>
                  </li>
                  <li>
                    <p>{t(item.item3Key)}</p>
                    <img src={icon3} alt="" width={'25px'}/>
                  </li>
                  <li>
                    <p>{t(item.item4Key)}</p>
                    <img src={icon4} alt="" width={'25px'}/>
                  </li>
                </ul>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}
export default SectionFour;
